module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAA8UlEQVRIS+2V0QlCMQxFz9tEJ1EnUSdRJ1EnUSfRUeRCK219bVKQh6D5TnOSm0s6MEEMEzD4CsgGOHZO+wDm6RtrkguwBLZO0AzYQa6QB6KHWWcNoBpSY1nd34Fo8Vrk1bmTbrnkKj0qQ8CaEbogd0ALV0FNksYNOFUmc0P2wYbqtlaspp4bIgsqVs49pGkmRAmSR1JJIkEkWSlXi92ExPNxANah8DmclB7ZmhB1POamtztkSGjKVYIiQFN6DWBC1GQExXslp0m+j9+udNly2v9AvjxinfroOFnbEwtARun6T+KJ8QCqP641SW/x0fxJIE/35DkaCqpXFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portrait.png
// module id = 3wUI
// module chunks = 2